import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/empty-state.svg'


const _hoisted_1 = { class: "flex flex-col items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "mt-8 text-center text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, " There are no " + _toDisplayString(_ctx.name) + " created yet. ", 1)
  ]))
}